// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import ResourceLinkSchema from './resource-link-schema';
import UserApiKeySettingsSchema from './user-api-key-settings-schema';

const schema = {
  $id: '/generate-api-key-request-schema',
  type: 'object',
  required: ['id', 'creatorId', 'userId', 'name'],
  properties: {
    id: {
      type: 'integer',
    },
    links: {
      type: 'array',
      nullable: true,
      items: { ...ResourceLinkSchema },
    },
    creatorId: {
      type: 'integer',
    },
    creatorName: {
      type: 'string',
      nullable: true,
    },
    created: {
      type: 'string',
      format: 'date-time',
    },
    modifierId: {
      type: 'integer',
      nullable: true,
    },
    modifierName: {
      type: 'string',
      nullable: true,
    },
    modified: {
      type: 'string',
      format: 'date-time',
      nullable: true,
    },
    userId: {
      type: 'integer',
    },
    name: {
      type: 'string',
      minLength: 6,
    },
    apiKeyOptions: {
      ...UserApiKeySettingsSchema,
    },
  },
} as IJSONSchema;

export default schema;
